"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
exports.generateClassName = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var maps = mapArray(args);
    return classnames_1.default(maps);
};
var mapArray = function (array) {
    return array.map(function (arg) {
        if (typeof arg === 'string')
            return arg;
        if (Array.isArray(arg))
            return mapArray(arg);
        return undefined;
    });
};
